import React from 'react';
import PropTypes from 'prop-types';

import {styled} from "@mui/material/styles";

import {black500, greyishBlue400} from "assets/jss/main";

ListingProductDetails.propTypes = {
    details: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.node.isRequired,
        value: PropTypes.node,
    })).isRequired,
};

const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginTop: '4px',
    width: '100%',
    fontSize: '12px',
    fontWeight: 400
});

const Line = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    width: '100%',
    minWidth: 0
});

const Label = styled('span')({
    color: greyishBlue400,
    whiteSpace: 'nowrap',
    flexShrink: 0
});

const Value = styled('span')({
    color: black500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

function ListingProductDetails({details}) {
    return (
        <Container>
            {details.filter((detail) => detail.value).map((detail, index) => (
                <Line key={index}>
                    <Label>{detail.label} :</Label>
                    <Value>{detail.value}</Value>
                </Line>
            ))}
        </Container>
    );
}

export default ListingProductDetails;
